import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LookupService } from 'src/app/services/lookup.service';

@Component({
  selector: 'app-dropdown-field',
  templateUrl: './dropdown-field.component.html',
  styleUrl: './dropdown-field.component.css'
})
export class DropdownFieldComponent implements ICellRendererAngularComp {
  unionTypeValues = [];
  unionStatusValues = [];
  evaluationValues = [];
  legitStatusValues = [];
  newValue: any;
  filterDataValue: any;
  currentValue: any;
  refresh(_params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
  params;
  optionsList: string[] = []
  currentField!: string
  selectedValue!: any
  showEmptyOption: boolean

  constructor(private readonly lookup: LookupService) {}

  agInit(params) {
    this.params = params;
    const filterdModel = this.params.api
    this.currentField = this.params.column.colId
    this.currentValue = params.value ?? ''
    this.showEmptyOption = !params.value
    if (filterdModel[this.currentField] != undefined || filterdModel[this.currentField] != null) {  //NOSONAR 
      if (filterdModel[this.currentField]?.filter.length !== 0) {
        this.selectedValue = filterdModel[this.currentField].filter
      }
      else {
        this.selectedValue = null
      }
    }
    this.setUnionFilterData()
    if(this.currentField === 'uniontype') {
      this.optionsList = this.unionTypeValues
    }
    if(this.currentField === 'legitimizationstatus') {
      this.optionsList = this.legitStatusValues
    }
    if(this.currentField === 'unionstatus') {
      this.optionsList = this.unionStatusValues
    }
    if(this.currentField === 'evaluation') {
      this.optionsList = this.evaluationValues
    }    
  }

  setUnionFilterData() {
    this.lookup.getFilterData().subscribe(data => {
      this.filterDataValue = data.body
      this.unionTypeValues = data.body?.unionType
      this.unionStatusValues = data.body?.unionStatus
      this.evaluationValues = data.body?.evaluation
      this.legitStatusValues = data.body?.legit
    })
  }

  get displayDropdownValue(): string {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (this.params.data.editable && tempData) {
      return tempData[this.params.colDef.field];
    }
    return this.params.data[this.params.colDef.field];
  }

  onSelectChange(event: any) {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (tempData) {
      tempData[this.params.colDef.field] = event; // Mutate temp state only
    }
  }
}